<template>
    <div class="footer-content">
        <div class="content">
            <div class="title">
                <img src="../assets/logo-footer.webp" alt="logo" />
                HELLOGOLD (THAILAND) LIMITED
            </div>
            <div class="item-box">
                <div class="item" v-for="item in list" :key="item.index">
                    <img :src="require('@/assets/footer-icon' + item.index + '.webp')" alt="">
                    {{ item.content }}
                </div>
            </div>
        </div>
        <div class="bottom">
            © 2026 HELLOGOLD (THAILAND) LIMITED
        </div>
    </div>
</template>
<script setup>
const list = [
    {
        content: "info@hellogold-thai.com",
        index: 1,
    },
    {
        content: "88/8 ซอยนวลน้อย แขวงคลองตันเหนือ เขตวัฒนา กรุงเทพมหานคร",
        index: 2,
    },
    {
        content: "+66 0619348526",
        index: 3,
    }
];
</script>
<style lang="less" scoped>
.footer-content {
    width: 100%;
    height: 260px;
    background: #2B2929;
    padding: 0 270px;
    box-sizing: border-box;

    .content {
        width: 100%;
        padding: 38px 0;
        box-sizing: border-box;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);

        .title {
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: bold;
            font-size: 24px;
            color: #FFFFFF;
            line-height: 24px;
            letter-spacing: 1px;
            text-shadow: 0px 1px 0px #333333;
            margin-bottom: 38px;

            img {
                width: 60px;
                height: 60px;
                object-fit: contain;
                margin-right: 17px;
            }
        }

        .item-box {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .item {
                max-width: 415px;
                display: flex;
                align-items: center;
                font-size: 14px;
                color: rgba(255, 255, 255, 0.8);
                line-height: 20px;
                text-shadow: 0px 1px 0px #333333;

                img {
                    width: 15px;
                    object-fit: cover;
                    margin-right: 5px;
                }
            }
        }
    }

    .bottom {
        margin-top: 14px;
        font-weight: 400;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.8);
        line-height: 18px;
        text-shadow: 0px 1px 0px #333333;
        text-align: center;
    }
}
</style>